import { useContext } from 'react';
import { TutorialContext } from './TutorialContext';
import type { TutorialContextType } from './types';

export const useTutorial = (): TutorialContextType => {
  const ctx = useContext(TutorialContext);
  if (!ctx) throw new Error('useTutorial must be used within TutorialProvider');
  return ctx;
};
